export const getPageIsNotFound = (state) => state.redirect.isNotFound;
export const getRedirectIsFetching = (state) => state.redirect.isFetching;
